import {createRouter, createWebHistory} from 'vue-router'

const router = createRouter({
   history: createWebHistory(process.env.BASE_URL),
   routes: [
      {path: '/', name: 'Login',meta:{title: 'Login'}	, component: () => import(/* webpackChunkName: "Login" */ '../views/Login/Login.vue')},
      {
         path: '/dash',
         name: 'Dash',
         component: () => import(/* webpackChunkName: "Dash" */ '../views/Dash.vue'),
         children: [
            {
               path: '/principal',
               name: 'Principal',
               meta:{title: 'Principal'},
               component: () => import(/* webpackChunkName: "about" */ '../views/Home/Principal.vue')
            },
            {
               path: '/sincronizar',
               name: 'Sincronizar',
               meta:{title: 'Sincronizar'},
               component: () => import(/* webpackChunkName: "Sincronizar" */ '../views/Sincronizacao/Sincronizacao.vue')
            },
            {
               path: '/relatorio/cidades',
               name: 'Cidades',
               meta:{title: 'Cidades'},
               component: () => import(/* webpackChunkName: "Cidades" */ '../views/Relatorios/Cidades.vue')
            },
            {
               path: '/relatorio/clientes',
               name: 'Clientes',
               meta:{title: 'Clientes'},
               component: () => import(/* webpackChunkName: "Cidades" */ '../views/Relatorios/ClientesTopsap.vue')
            },
            {
               path: '/parametros',
               name: 'Parametros',
               meta: { title: 'Parametros' },
               component: () => import(/* webpackChunkName: "parametros" */ '../views/Cadastros/parametros/Parametros.vue')
            },
          {
               path: '/usuarios',
               name: 'Usuarios',
               meta: { title: 'Usuarios' },
               component: () => import(/* webpackChunkName: "usuarios" */ '../views/Cadastros/usuarios/Usuario.vue')
            }


         ]
      },
      {
         path: '/:pathMatch(.*)*',
         name: 'not-found',
         meta:{title: 'Não Encontrado'},
         component: () => import(/* webpackChunkName: "404" */ '../views/NotFound/NotFound.vue')
      },

   ]
});
router.beforeEach((to, from) => {
   document.title = (to.meta?.title + ' - ' + 'Web Topsap BI')  ?? 'Web Topsap BI'
})

export default router
